
















import { printA3LandscapePDF } from "@/helpers/printPDF";
import { format } from "date-fns";
import { Component, Prop, Vue } from "vue-property-decorator";
import SalesReportPresentationModel from "../presenters/sales-report-presentation-model";
import SalesReportChart from "./SalesReportChart.vue";
import SalesReportQuery, {
  GetSalesReportQueryDetails
} from "./SalesReportQuery.vue";
import SalesReportSales from "./SalesReportSales.vue";
import SalesReportTable from "./SalesReportTable.vue";
import SalesSummary from "./SalesSummary.vue";

@Component({
  components: {
    SalesSummary,
    SalesReportChart,
    SalesReportSales,
    SalesReportTable,
    SalesReportQuery
  }
})
export default class PrintSalesReport extends Vue {
  @Prop({ type: String }) subject!: string;
  @Prop({ type: String }) month!: string;
  @Prop({ type: Object, required: true }) report!: SalesReportPresentationModel;
  @Prop({ type: Object, required: true }) chart!: {
    labels: string[];
    data: number[];
    purchaseLabels: string[];
    purchaseData: number[];
    profitabilityData: number[];
  };
  @Prop({ type: Object }) query?: GetSalesReportQueryDetails;

  get today() {
    return format(new Date(), "yyyy-MM-dd HH:mm:dd");
  }

  public print() {
    const el = this.$refs["printElement"] as HTMLElement;
    if (!el) {
      throw new Error("Element is not found.");
    }
    let subject = this.subject ? this.subject : "全体";
    const filename =
      "[請求レポート]_" + subject + "_" + this.today.substr(0, 10);
    printA3LandscapePDF(el, filename);
  }
}
